import { useQuery } from '@tanstack/react-query';
import { dashboardApi, dashboardQueryKeys, type StatisticPeriod } from '../api/dashboard.api';

export function useAccountantReports(period: StatisticPeriod) {
  return useQuery({
    queryKey: dashboardQueryKeys.accountantReports(period),
    queryFn: () => dashboardApi.getAccountantReports(period),
  });
}
